import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { BonusSettlementSearchCustomer } from '../../features/bonus-settlements/detail/models/bonus-settlement-supplier-overview';
import { Customer } from '../models/customer';

export class CustomerApi {
    constructor(protected baseUrl: string) {}

    public get(id: number): Promise<ApiResult<Customer>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/customers/${id}/details`),
            response => Customer.fromPlainObject(response.data)
        );
    }

    public cget(
        params: URLSearchParams = new URLSearchParams(),
        abortSignal?: AbortSignal
    ): Promise<ApiResult<PaginatedResponse<Customer>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/customers`, { params, signal: abortSignal }),
            response => {
                response.data.items = response.data.items.map(Customer.fromPlainObject);
                return response.data;
            }
        );
    }

    public search(params: URLSearchParams = new URLSearchParams()): Promise<ApiResult<PaginatedResponse<Customer>>> {
        params.append('types', 'customer');
        params.append('contactIsLocked', 'false');

        return safeRequest(
            () => request.get(`${this.baseUrl}/quicksearch/accounts`, { params }),
            response => {
                response.data.items = response.data.items.map(Customer.fromPlainObject);
                return response.data;
            }
        );
    }

    public getCustomerBonusSettlements(
        id: number,
        supplierBonusSettlementId: number,
        params: URLSearchParams = new URLSearchParams(),
        abortSignal?: AbortSignal
    ): Promise<ApiResult<PaginatedResponse<BonusSettlementSearchCustomer>>> {
        return safeRequest(
            () =>
                request.get(
                    `${this.baseUrl}/bonus-settlements/${id}/suppliers/${supplierBonusSettlementId}/available-customers`,
                    { params, signal: abortSignal }
                ),
            response => response.data
        );
    }
}
